// Slugs stay URL-readable. We keep Latin and Arabic (and any other script's)
// letters, decimal digits and hyphens — browsers render non-ASCII slugs fine,
// even when percent-encoded. Tatweel, Arabic diacritics, punctuation and
// symbols are dropped; Arabic-Indic digits are normalized to ASCII.

const ARABIC_TO_ASCII_DIGITS: Record<string, string> = {
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9",
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9",
};

const normalizeDigits = (input: string): string =>
  input.replace(
    /[٠-٩۰-۹]/g,
    (digit) => ARABIC_TO_ASCII_DIGITS[digit] ?? digit,
  );

export const slugify = (input: string): string => {
  if (!input) return "";
  return normalizeDigits(input)
    .toLowerCase()
    .replace(/ـ/g, "") // tatweel (kashida)
    .replace(/[^\p{L}\p{Nd}\s-]/gu, "") // keep letters + decimal digits only
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
};

export const SLUG_PATTERN = /^[\p{L}\p{Nd}]+(?:-[\p{L}\p{Nd}]+)*$/u;
